import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthActions } from '@src/app/store/auth/auth.actions';
import { AuthSelectors } from '@src/app/store/auth/auth.selectors';
import { combineLatest, filter, map, take, tap } from 'rxjs';

/**
 * Guard that ensures the user has a KAM assigned before allowing access to protected routes.
 * If KAM data is not loaded, it triggers the loading action and waits for completion.
 * Redirects to /services if the user doesn't have a KAM.
 */
export const kamRequiredGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(AuthSelectors.selectLoadingKam),
    store.select(AuthSelectors.selectKam),
  ]).pipe(
    tap(([loadingKam, kamData]) => {
      if (kamData === undefined && !loadingKam) {
        store.dispatch(AuthActions.loadKam());
      }
    }),
    filter(([loadingKam, kamData]) => !loadingKam && kamData !== undefined),
    take(1),
    map(([, kamData]) => {
      const hasKam = !!(
        kamData?.NOMBRE_DS ||
        kamData?.EMAIL_DS ||
        kamData?.TELEFONO_DS
      );

      if (!hasKam) {
        router.navigate(['/services']);
        return false;
      }

      return true;
    }),
  );
};
